// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"8a48b7a9205de903","312":"3de76465e2953142","411":"27999061a1bad427"}[chunkId] + ".js";
};